import styled, { css } from 'styled-components'

import { premiumFontCss } from '@root/entities/premium/ui'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  children: React.ReactNode
} & ClassNameProps

export const CheckCurrencyFooter: React.FC<Props> = ({
  children,
  className,
}) => (
  <Footer className={className}>
    <Separator />
    <Note>{children}</Note>
  </Footer>
)

const Footer = styled.div`
  display: grid;
`

const Separator = styled.span`
  opacity: 0.1;
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #fff 50%,
    transparent 100%
  );
  margin: 18px 0;

  ${mediaMinTablet(css`
    display: none;
  `)}
`

const Note = styled.div`
  color: var(--text-12);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  p {
    font-size: var(--typography-body-4-bold-font-size);
  }

  span {
    ${premiumFontCss}

    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: var(--typography-body-4-bold-font-weight);
    line-height: var(--typography-body-4-bold-line-height);
  }
`
